export const StatusTypes = Object.freeze({
    NEW: 'New',
    INREVIEW: 'In Review',
    ACTIVE : 'Active',
    REJECTED: 'Rejected',
    RETIRED: 'Retired'
  });

  export const DEFAULT_STATUS = StatusTypes.NEW;

  export const AutomationStatusTypes = Object.freeze({
    NOT_AUTOMATED: 'Not Automated',
    AUTOMATION_IN_PROGRESS: 'Automation In Progress',
    AUTOMATED: 'Automated'
  });

  export const DEFAULT_AUTOMATION_STATUS = AutomationStatusTypes.NOT_AUTOMATED;